import { render } from "./Index.vue?vue&type=template&id=b8ec0d7a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pre/survey/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8ec0d7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8ec0d7a', __exports__)) {
    console.log('reload')
    api.reload('b8ec0d7a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=b8ec0d7a", () => {
    console.log('re-render')
    api.rerender('b8ec0d7a', render)
  })

}


export default __exports__